import React from "react";
import { createRoot } from "react-dom/client";
import { MemoryRouter } from "react-router-dom";
import ToastProvider from "../components/shared/ToastProvider";
import SkillSheetMainCreateStepper from "../components/skill_sheet_main/pages/create/SkillSheetMainCreateStepper";

// ======== プロジェクト入力フォームのデモ（TOPページ埋め込み） ========
// 未ログイン訪問者向けに、実際の skill_sheet_mains/new のステッパーを
// デモモードで動かす。マスタデータ取得は公開 autocomplete エンドポイントを使う
document.addEventListener("DOMContentLoaded", () => {
  const containers = document.querySelectorAll(".react-skill-sheet-main-demo");

  containers.forEach((container) => {
    if (!container || container.__reactRoot) return;

    container.__reactRoot = createRoot(container);
    container.__reactRoot.render(
      <React.StrictMode>
        <ToastProvider>
          <MemoryRouter>
            <SkillSheetMainCreateStepper demo />
          </MemoryRouter>
        </ToastProvider>
      </React.StrictMode>,
    );
  });
});
